// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__tl2qO","title":"Footer_title__-rzTJ","socials":"Footer_socials__bqeqA","icon":"Footer_icon__RWVrh"};